import api from "./api";

const UserRoleAPI = {
    getRolesByUser: (userId) => api.get(`/user-roles/user/${userId}`),
    assignUserRole: (data) => api.post(`/user-roles/update-user-roles`, data)
};

export default UserRoleAPI;